import { productUrlPrefix } from './url-utils';

export const gameUrl = ({ gameId, product = 'waybetter' }) =>
  `${productUrlPrefix(product)}/games/${gameId}`;
